import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Link, useLocation } from 'react-router-dom';
import LoadingIndicator from "../../common/loadingIndicator";
import loadingStatus from "../../../helpers/loadingStatus";
import useJsonForm from '../../../hooks/useJsonForm';
import { JsonForms } from '@jsonforms/react';
import { materialRenderers, materialCells } from '@jsonforms/material-renderers';
import usePutRequest from '../../../hooks/usePutRequest';
import getListOfCrops from '../../../helpers/getListOfCrops';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import removeOldIssues from '../../../helpers/removeOldIssues';
import UrlControl, {
    urlControlTester,
} from '../../customControls/UrlControl';
import BenchMarkingControl, {
    benchMarkingControlTester,
} from '../../customControls/BenchMarkingControl';
import { ArrowLeft, ArrowRight } from 'react-bootstrap-icons';
import SurveyNavigation from '../surveyNavigation';
import getListOfOtherCrops from '../../../helpers/getListOfOtherCrops';
import getListOfNonOtherCrops from '../../../helpers/getListOfNonOtherCrops';

const AddOtherPest = (props) => {

    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (location.state === null || location.state.surveyData === null) {
            navigate("/farm-list");
        };
    });
    const { put } = usePutRequest(`/api/survey/${location.state?.surveyData?.id}`, location.state?.surveyData);
    const { jsonForm, loadingState } = useJsonForm(`661e30e21da5f831d8f81668`);

    const initialisePest = (listOfParcels) => {
        let listOfOtherCrops = listOfParcels.map(parcel => parcel.crops).flat().filter(crop => crop.isOther);
        let val = listOfOtherCrops.map(crop => {
            return {
                cropName: crop.cropType,
                pests: []
            };
        })

        return val;
    }

    const initialData = (location.state !== null && location.state.surveyData !== null && location.state.surveyData.otherCrops !== null) ?
        (location.state.surveyData.otherCrops.length !== 0) ?
            location.state.surveyData.otherCrops :
            initialisePest(location.state.surveyData.landParcels) :
        initialisePest(location.state.surveyData.landParcels);

    const status = (location.state !== null && location.state.surveyData !== null) && location.state.surveyData.status;
    const [allData, setAllData] = useState(initialData);

    const UpdateData = (data, otherCrop) => {
        if (data === undefined)
            return;
        let index = allData.map(dat => dat.cropName.toLowerCase()).indexOf(otherCrop.toLowerCase());
        allData[index].pests = data;
    }

    const currentMeasuresIndex = 0;
    const listOfCrops = getListOfCrops(location.state?.surveyData.landParcels);
    const listOfOtherCrops = getListOfOtherCrops(location.state?.surveyData.landParcels);
    removeOldIssues(location.state?.surveyData?.pests, listOfCrops);
    removeOldIssues(location.state?.surveyData?.diseases, listOfCrops);

    if (loadingState !== loadingStatus.loaded)
        return <LoadingIndicator loadingState={loadingState} />;

    const schema = JSON.parse(jsonForm.schema);
    const uiSchema = JSON.parse(jsonForm.uiSchema);

    const onAddPestSubmitClick = async (goToNextPage) => {

        location.state.surveyData.otherCrops = allData;

        const response = await put();
        if (!response.isValid) {
            toast.error(response.message, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
            });
            return;
        }

        if (!goToNextPage) {
            toast.info("Saved", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
            });
            return;
        }
        
        let finalUrl = '/add-pests-resistance'
        

        navigate(finalUrl,
            {
                state: {
                    farmData: location.state.farmData,
                    surveyData: location.state.surveyData,
                    crops: listOfCrops,
                    index: currentMeasuresIndex
                }
            });
    };
    let listOfNonOtherCrops = getListOfNonOtherCrops(location.state.surveyData.landParcels)
    let prevUrl;
    if (listOfNonOtherCrops.length !== 0) {
        prevUrl = `/add-pests-measures/${listOfNonOtherCrops[listOfNonOtherCrops.length - 1]}`;
    } else {
        prevUrl = "add-weeds-resistance";
    }

    return (
        <>
            <div className="row my-3">
                <h1 className="text-uppercase font-weight-bold">
                    {location.state.farmData.name} - <u>pest issues</u> - {location.state.surveyData.year}
                </h1>
                <p>Please select the category you feel best represents the level of risk on your farm</p>
            </div>
            <div className="row my-3">
                {listOfOtherCrops.length === 0 &&
                    <h3>No crops selected</h3>
                }
                {
                    listOfOtherCrops.map((otherCrop, index) => {
                        return (
                            <>
                                <h2>{otherCrop}</h2>
                                <JsonForms validationMode={'NoValidation'}
                                    key={index}
                                    schema={schema}
                                    data={allData.filter(dat => dat.cropName.toLowerCase().trim() === otherCrop.toLowerCase().trim())[0].pests}
                                    uischema={uiSchema}
                                    renderers={materialRenderers}
                                    cells={materialCells}
                                    onChange={({ errors, data }) => UpdateData(data, otherCrop)}
                                    readonly={status === 'completed'}
                                />
                            </>
                        )
                    }
                    )
                }
            </div>
            <div className="row justify-content-between my-5">
                <div className="alert alert-info" role="alert">
                    To save your work, click <strong>Save</strong> before using the <strong>Go To</strong> or <strong>Go back</strong> button.
                </div>
                <Link className="col-2 mx-3" to="/farm-list">
                    <button type="button" className="btn btn-danger">Cancel and go back to your farms</button>
                </Link>
                <Link className="col-2 mx-3"
                    to={ prevUrl }
                    state={{
                        farmData: location.state.farmData,
                        surveyData: location.state.surveyData,
                        crops: listOfCrops
                    }}>
                    <button type="button" className="btn btn-warning w-100 h-100"><ArrowLeft size={20} className="mx-2"></ArrowLeft>Go back</button>
                </Link>
                <SurveyNavigation farmData={location.state.farmData} surveyData={location.state.surveyData} crops={location.state.crops} />
                <button type="button" className="col-2 mx-3 btn btn-primary" onClick={() => onAddPestSubmitClick(false)} disabled={status === 'completed'} >Save</button>
                {status === 'completed' ? (
                    <button type="button" className="col-2 mx-3 btn btn-success" onClick={() => onAddPestSubmitClick(true)}>Continue</button>
                ) : (
                    <button type="button" className="col-2 mx-3 btn btn-success" onClick={() => onAddPestSubmitClick(true)}>Save and continue<ArrowRight size={20} className="mx-2"></ArrowRight></button>
                )}
            </div>
        </>
    );
};

export default AddOtherPest;
